import { RESOURCE_STATUS } from '../../common/constants';

/**
 * The class that colours a resource's title and date by how its generation
 * went. Shared so a row in the phone list reads the same as one in the table.
 *
 * @param {String} status The resource's status, one of RESOURCE_STATUS
 * @returns {String} The class name, or an empty string for a finished resource
 */
export const getStatusClass = (status) => {
  if (status === RESOURCE_STATUS.ERROR) return 'errorText';
  if (status === RESOURCE_STATUS.IN_PROGRESS) return 'inProgressText';
  return '';
};

/**
 * Whether a resource is still generating.
 * @param {Object} resource The resource, one of RESOURCE_STATUS in its status field
 * @returns {Boolean} Whether the resource is still in progress
 */
export const isResourcePending = (resource) => resource.status === RESOURCE_STATUS.IN_PROGRESS;
